import gsap from 'gsap';

import Experience from '../Experience';
import Car from './Car';

const loader = document.querySelector('.loader-body');
const next = document.querySelector('[data-next-scene]');

export default class World {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.canvas = this.experience.canvas;
        this.resources = this.experience.resources;

        this.resources.on('ready', () => {

            this.car = new Car();
            gsap.timeline()
                .to(loader, {autoAlpha : 0, duration: 1})
                .to(next, {autoAlpha : 1});
        });
    }

    update() {
        if(this.car) this.car.update();
    }
}